import MessageTable from "./components/message-table/messagetable";

const MessagesTables = () => {
  return (
    <div>
      <div className="mt-5 grid h-full grid-cols-1 gap-5 md:grid-cols-1">
        <MessageTable />
      </div>
    </div>
  );
};

export default MessagesTables;
